import { toJson } from "../json";
export async function getRequestBody({ body, type }) {
    if (type.includes("json")) {
        return toJson(body);
    }
    else {
        return body;
    }
}
